var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"body-class":"d-flex justify-content-center align-items-center"}},[_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-spinner')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }